import { jsx as _jsx } from "react/jsx-runtime";
import { t } from '@/core/localization';
import trashIcon from '@/core/svg/fa/trash.svg';
import { forwardRef } from 'react';
import { ActionIconTemplate } from './ActionIconTemplate';
export const DeleteActionIcon = forwardRef((props, ref) => (_jsx(ActionIconTemplate, { ref: ref, ...props, icon: trashIcon, defaultTitle: t('delete.label') })));
